// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import {
  SimulationOpcUaNodeValues,
  SimulationOpcUaNodeValuesT,
  verifySimulationOpcUaNodeValues,
} from "./simulation-opc-ua-node-values";
import { AdapterProtocol } from "../archive/adapter-protocol";
import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * A bank a scenario can drive, as `LiftCloud` resolves it from
 * bank, channel and adapter.
 */
export class SimulationTarget implements flatbuffers.IUnpackableObject<SimulationTargetT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): SimulationTarget {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsSimulationTarget(
    bb: flatbuffers.ByteBuffer,
    obj?: SimulationTarget,
  ): SimulationTarget {
    return (obj || new SimulationTarget()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsSimulationTarget(
    bb: flatbuffers.ByteBuffer,
    obj?: SimulationTarget,
  ): SimulationTarget {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new SimulationTarget()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  bankId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  bankName(): string | null;
  bankName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  bankName(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  serverId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  channelId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  adapterName(): string | null;
  adapterName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  adapterName(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  protocol(): AdapterProtocol {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : AdapterProtocol.MCE;
  }

  /**
   * Channel vendor socket address, or OPC UA endpoint URL.
   */
  vendorAddress(): string | null;
  vendorAddress(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  vendorAddress(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * OPC UA bank vendor paths (location, site, group).
   */
  vendorLocationPath(): string | null;
  vendorLocationPath(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  vendorLocationPath(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  vendorSitePath(): string | null;
  vendorSitePath(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  vendorSitePath(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  vendorGroupPath(): string | null;
  vendorGroupPath(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  vendorGroupPath(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * Node ids and values from the adapter's OPC UA mapping.
   */
  opcuaNodes(index: number, obj?: SimulationOpcUaNodeValues): SimulationOpcUaNodeValues | null {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset
      ? (obj || new SimulationOpcUaNodeValues()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  opcuaNodesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  static startSimulationTarget(builder: flatbuffers.Builder) {
    builder.startObject(11);
  }

  static addBankId(builder: flatbuffers.Builder, bankIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, bankIdOffset, 0);
  }

  static addBankName(builder: flatbuffers.Builder, bankNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, bankNameOffset, 0);
  }

  static addServerId(builder: flatbuffers.Builder, serverIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, serverIdOffset, 0);
  }

  static addChannelId(builder: flatbuffers.Builder, channelIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, channelIdOffset, 0);
  }

  static addAdapterName(builder: flatbuffers.Builder, adapterNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, adapterNameOffset, 0);
  }

  static addProtocol(builder: flatbuffers.Builder, protocol: AdapterProtocol) {
    builder.addFieldInt8(5, protocol, AdapterProtocol.MCE);
  }

  static addVendorAddress(builder: flatbuffers.Builder, vendorAddressOffset: flatbuffers.Offset) {
    builder.addFieldOffset(6, vendorAddressOffset, 0);
  }

  static addVendorLocationPath(
    builder: flatbuffers.Builder,
    vendorLocationPathOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(7, vendorLocationPathOffset, 0);
  }

  static addVendorSitePath(builder: flatbuffers.Builder, vendorSitePathOffset: flatbuffers.Offset) {
    builder.addFieldOffset(8, vendorSitePathOffset, 0);
  }

  static addVendorGroupPath(
    builder: flatbuffers.Builder,
    vendorGroupPathOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(9, vendorGroupPathOffset, 0);
  }

  static addOpcuaNodes(builder: flatbuffers.Builder, opcuaNodesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(10, opcuaNodesOffset, 0);
  }

  static createOpcuaNodesVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startOpcuaNodesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static endSimulationTarget(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  unpack(): SimulationTargetT {
    return new SimulationTargetT(
      this.bankId() !== null ? this.bankId()!.unpack() : null,
      this.bankName(),
      this.serverId() !== null ? this.serverId()!.unpack() : null,
      this.channelId() !== null ? this.channelId()!.unpack() : null,
      this.adapterName(),
      this.protocol(),
      this.vendorAddress(),
      this.vendorLocationPath(),
      this.vendorSitePath(),
      this.vendorGroupPath(),
      this.bb!.createObjList<SimulationOpcUaNodeValues, SimulationOpcUaNodeValuesT>(
        this.opcuaNodes.bind(this),
        this.opcuaNodesLength(),
      ),
    );
  }

  unpackTo(_o: SimulationTargetT): void {
    _o.bankId = this.bankId() !== null ? this.bankId()!.unpack() : null;
    _o.bankName = this.bankName();
    _o.serverId = this.serverId() !== null ? this.serverId()!.unpack() : null;
    _o.channelId = this.channelId() !== null ? this.channelId()!.unpack() : null;
    _o.adapterName = this.adapterName();
    _o.protocol = this.protocol();
    _o.vendorAddress = this.vendorAddress();
    _o.vendorLocationPath = this.vendorLocationPath();
    _o.vendorSitePath = this.vendorSitePath();
    _o.vendorGroupPath = this.vendorGroupPath();
    _o.opcuaNodes = this.bb!.createObjList<SimulationOpcUaNodeValues, SimulationOpcUaNodeValuesT>(
      this.opcuaNodes.bind(this),
      this.opcuaNodesLength(),
    );
  }

  unpackFields(...fields: string[]): SimulationTargetT {
    const t = new SimulationTargetT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("bank_id")) {
      t.bankId = this.bankId() !== null ? this.bankId()!.unpack() : null;
    }
    if (fieldSet.has("bank_name")) {
      t.bankName = this.bankName();
    }
    if (fieldSet.has("server_id")) {
      t.serverId = this.serverId() !== null ? this.serverId()!.unpack() : null;
    }
    if (fieldSet.has("channel_id")) {
      t.channelId = this.channelId() !== null ? this.channelId()!.unpack() : null;
    }
    if (fieldSet.has("adapter_name")) {
      t.adapterName = this.adapterName();
    }
    if (fieldSet.has("protocol")) {
      t.protocol = this.protocol();
    }
    if (fieldSet.has("vendor_address")) {
      t.vendorAddress = this.vendorAddress();
    }
    if (fieldSet.has("vendor_location_path")) {
      t.vendorLocationPath = this.vendorLocationPath();
    }
    if (fieldSet.has("vendor_site_path")) {
      t.vendorSitePath = this.vendorSitePath();
    }
    if (fieldSet.has("vendor_group_path")) {
      t.vendorGroupPath = this.vendorGroupPath();
    }
    if (fieldSet.has("opcua_nodes")) {
      t.opcuaNodes = this.bb!.createObjList<SimulationOpcUaNodeValues, SimulationOpcUaNodeValuesT>(
        this.opcuaNodes.bind(this),
        this.opcuaNodesLength(),
      );
    }
    return t;
  }
}

export class SimulationTargetT implements flatbuffers.IGeneratedObject {
  constructor(
    public bankId: UuidT | null = null,
    public bankName: string | Uint8Array | null = null,
    public serverId: UuidT | null = null,
    public channelId: UuidT | null = null,
    public adapterName: string | Uint8Array | null = null,
    public protocol: AdapterProtocol = AdapterProtocol.MCE,
    public vendorAddress: string | Uint8Array | null = null,
    public vendorLocationPath: string | Uint8Array | null = null,
    public vendorSitePath: string | Uint8Array | null = null,
    public vendorGroupPath: string | Uint8Array | null = null,
    public opcuaNodes: SimulationOpcUaNodeValuesT[] = [],
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const bankId = this.bankId !== null ? this.bankId!.pack(builder) : 0;
    const bankName = this.bankName !== null ? builder.createString(this.bankName!) : 0;
    const serverId = this.serverId !== null ? this.serverId!.pack(builder) : 0;
    const channelId = this.channelId !== null ? this.channelId!.pack(builder) : 0;
    const adapterName = this.adapterName !== null ? builder.createString(this.adapterName!) : 0;
    const vendorAddress =
      this.vendorAddress !== null ? builder.createString(this.vendorAddress!) : 0;
    const vendorLocationPath =
      this.vendorLocationPath !== null ? builder.createString(this.vendorLocationPath!) : 0;
    const vendorSitePath =
      this.vendorSitePath !== null ? builder.createString(this.vendorSitePath!) : 0;
    const vendorGroupPath =
      this.vendorGroupPath !== null ? builder.createString(this.vendorGroupPath!) : 0;
    const opcuaNodes = SimulationTarget.createOpcuaNodesVector(
      builder,
      builder.createObjectOffsetList(this.opcuaNodes),
    );

    SimulationTarget.startSimulationTarget(builder);
    SimulationTarget.addBankId(builder, bankId);
    SimulationTarget.addBankName(builder, bankName);
    SimulationTarget.addServerId(builder, serverId);
    SimulationTarget.addChannelId(builder, channelId);
    SimulationTarget.addAdapterName(builder, adapterName);
    SimulationTarget.addProtocol(builder, this.protocol);
    SimulationTarget.addVendorAddress(builder, vendorAddress);
    SimulationTarget.addVendorLocationPath(builder, vendorLocationPath);
    SimulationTarget.addVendorSitePath(builder, vendorSitePath);
    SimulationTarget.addVendorGroupPath(builder, vendorGroupPath);
    SimulationTarget.addOpcuaNodes(builder, opcuaNodes);

    return SimulationTarget.endSimulationTarget(builder);
  }

  clone(): SimulationTargetT {
    const obj = new SimulationTargetT();
    obj.bankId = this.bankId !== null ? this.bankId!.clone() : null;
    obj.bankName = this.bankName;
    obj.serverId = this.serverId !== null ? this.serverId!.clone() : null;
    obj.channelId = this.channelId !== null ? this.channelId!.clone() : null;
    obj.adapterName = this.adapterName;
    obj.protocol = this.protocol;
    obj.vendorAddress = this.vendorAddress;
    obj.vendorLocationPath = this.vendorLocationPath;
    obj.vendorSitePath = this.vendorSitePath;
    obj.vendorGroupPath = this.vendorGroupPath;
    obj.opcuaNodes = this.opcuaNodes.map((e) => e.clone());
    return obj;
  }

  equals(other: SimulationTargetT): boolean {
    if (this.bankId !== null && other.bankId !== null) {
      if (!this.bankId!.equals(other.bankId!)) return false;
    } else if (this.bankId !== other.bankId) return false;
    if (this.bankName !== other.bankName) return false;
    if (this.serverId !== null && other.serverId !== null) {
      if (!this.serverId!.equals(other.serverId!)) return false;
    } else if (this.serverId !== other.serverId) return false;
    if (this.channelId !== null && other.channelId !== null) {
      if (!this.channelId!.equals(other.channelId!)) return false;
    } else if (this.channelId !== other.channelId) return false;
    if (this.adapterName !== other.adapterName) return false;
    if (this.protocol !== other.protocol) return false;
    if (this.vendorAddress !== other.vendorAddress) return false;
    if (this.vendorLocationPath !== other.vendorLocationPath) return false;
    if (this.vendorSitePath !== other.vendorSitePath) return false;
    if (this.vendorGroupPath !== other.vendorGroupPath) return false;
    if (this.opcuaNodes.length !== other.opcuaNodes.length) return false;
    for (let i = 0; i < this.opcuaNodes.length; i++) {
      const a = this.opcuaNodes[i];
      const b = other.opcuaNodes[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    return true;
  }
}

export function verifySimulationTarget(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 8);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 10);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 14, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 16);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 18);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 20);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 22);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 24);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifySimulationOpcUaNodeValues);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
